export default __webpack_public_path__ + "static/media/warning--traffic-signals--g2.da23a41a.png";